//GLOBAL - components from npm
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//COMPONENTS
import Modal from "..";
import { Button, Typography } from "../../../general";
import Loading from "../../Loading";
import { Toast } from "../../../../utils/toast";

//SERVICES - api, conectors...
import * as APIOrganization from "../../../../services/api/organization";

//GLOBAL STATE - redux, env...

// UTILS

//ASSETS - icons, images...
import { ReactComponent as TrashIcon } from "../../../../assets/icons/Trash-3.svg";

//STYLES

import "./delete-organization.scss";

export default function DeleteOrganization({
    isOpen,
    onClose,
    organizations,
    organizationId,
    handleTableDataLookup,
    returnToOrganizationList = false,
    onDelete
}) {
    //REDUX - Selectors
    const token = useSelector((state) => state.auth.token);

    //GENERAL

    //STATES
    const [pageStatus, setPageStatus] = useState("awaiting");
    const [deletedOrganization, setDeletedOrganization] = useState(false);

    //FUNCTIONS
    function onCloseCustom() {
        onClose();
    };

    async function handleDeleteOrganization() {
        setPageStatus("deleting-organization");

        const data = {
            id_organizacao: organizationId,
        };

        try {
            const response = await APIOrganization.deleteOrganization(token, data)

            if (response.status === 200) {
                onDelete();
                onCloseCustom();
                Toast(
                    "Organização excluída!",
                    "Organização excluída com sucesso.",
                    "success"
                );

                setDeletedOrganization(true);

                if (returnToOrganizationList) {
                    returnToOrganizationList()
                }
            } else {
                const responseData = await response.json();
                throw new Error(responseData.message || "Falha ao excluir a organização.");
            }
        } catch (error) {
            console.error("Erro ao excluir a organização:", error);

            Toast(
                "Não foi possível excluir a organização!",
                "Verifique sua conexão e tente novamente mais tarde.",
                "error"
            );
        } finally {
            setPageStatus("awaiting");
        }
    };

    //USE MEMOS

    //USE EFFECTS 
    useEffect(() => {
        if (deletedOrganization) {
            handleTableDataLookup()
        }
    }, [deletedOrganization, organizations]);

    return (
        <Modal.Main
            className="modal-delete-organization"
            title="Excluir organização"
            width="443px"
            height="280px"
            titleColor={"black"}
            isOpen={isOpen}
            onClose={onClose}
            shouldCloseOnOverlayClick={false}
            headerContainerStyle={{ alignItems: "center" }}
            icon={
                <div className="modal-delete-organization__icon">
                    <TrashIcon />
                </div>
            }
            footer={
                <div className="container-footer">
                    <Button
                        onClick={() => onCloseCustom()}
                        className="modal-delete-organization__btn-cancel"
                        disabled={pageStatus === "deleting-organization"}
                    >
                        <Typography.H4 weight={"bold"} color="blue-selected-4">
                            Cancelar
                        </Typography.H4>
                    </Button>

                    <Button
                        className="modal-delete-organization__btn-confirm"
                        disabled={pageStatus === "deleting-organization"}
                        onClick={handleDeleteOrganization}
                    >
                        {pageStatus !== "deleting-organization" ? (
                            <Typography.H4 weight={"bold"} color="white">Excluir</Typography.H4>
                        ) : (
                            <Loading.Dots />
                        )}
                    </Button>
                </div>
            }
        >
            <Typography.H4
                color="gray-180"
                weight="400"
                className="information-text"
            >
                Você tem certeza que deseja excluir? Ao excluir todos os dados, serão excluídos e esta ação não poderá ser desfeita.
            </Typography.H4>
        </Modal.Main>
    )
}

